import moment from 'moment';
import { useEffect, useRef } from 'react';
import * as APIS from "../utils/service";
import store from '../redux/store';
import { listsetting1, listsetting1_2, listsetting1_3, listsetting2, listsetting2_2, listsetting2_3, listsetting3, listsetting3_2, listsetting3_3, seltypeorcategory } from '../redux/userInfo';

export const regPhone = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/; // 휴대폰번호
export const regEmail = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/; // 이메일

export const patternNum = /[0-9]/;	// 숫자 
export const patternPrice = /[0-9,]/;	// 금액 
export const patternEng = /[a-zA-Z]/;	// 영문 
export const patternEngUpper = /[A-Z]/;	// 영문 대문자
export const patternSpc = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/ ]/gim; // 특수문자 모두

export const patternSpcId = /[`~!#$%^&*()|+\=?;:'",<>\{\}\[\]\\\/ ]/gim; // 특수문자 아이디용
export const patternSpcId2 = /[`~!#$%^&*()|+\=?;:'"\-<>\{\}\[\]\\\/ ]/gim; // 특수문자 아이디용
export const patternSpcPw = /[|+\=?;:'",.<>\{\}\[\]\\\/ ]/gim; // 특수문자 비밀번호용
export const patternSpcEmail = /[`~!#$%^&*()|+\-=?;:'"<>\{\}\[\]\\\/ ]/gim; // 특수문자 이메일용
export const patternPwCker = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*?_]).{4,15}$/;

export const patternKor = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/; // 한글체크

export const patternOnlyNum = /[^0-9]/g

export const hpHypen = (str) => {
    return str.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
};

export const formatNumberWithCommas = (value) => {
    const numericValue = value.replace(/,/g, ""); // 콤마 제거
    if (numericValue === "") return ""; // 빈 문자열 처리
    if (/^\d+$/.test(numericValue)) {
        // 숫자만 있는지 확인
        return Number(numericValue).toLocaleString(); // 1000단위 콤마 추가
    }
    return ""; // 숫자가 아닌 경우 빈 문자열 반환
};

export const handleChangeValue = (e, setValue) => {
    const value = e.target.value;
    const numericValue = value.replace(/,/g, ""); // 콤마 제거

    if (/^\d*$/.test(numericValue)) {
        // 숫자 또는 빈 문자열만 허용
        const result = formatNumberWithCommas(value);
        setValue(result);
    }
};

export const numFormat = (num, milion = false) => {
    if (num) {
        let exnum = [];
        if (num?.toString().indexOf('.') != -1 && milion === false) {
            exnum = num?.toString().split('.');
            num = exnum[0];
            num = num.toString()?.replace(/,/g, '');
            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + exnum[1];
        } else {
            num = num.toString()?.replace(/,/g, '');
            if (num * 1 > 0) {
                num = Math.floor(num * 1);
            }

            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    } else {
        return 0;
    }
};

export const findJson = (object, val) => {
    let title = "정보없음";

    object.forEach((one, index) => {
        if ((one.idx * 1) === (val * 1)) {
            title = one.title;
        }
    })
    return title;
};

export const findJsonKey = (object, val, key) => {
    let title = "정보없음";

    object.forEach((one, index) => {
        if ((one.idx * 1) === (val * 1)) {
            title = one[key];
        }
    })
    return title;
};


export const findJsonImti = (object, val) => {
    let title = "👍";

    object.forEach((one, index) => {
        if ((one.idx * 1) === (val * 1)) {
            title = one.title;
        }
    })
    return title;
};


export const getFileName = (url) => {

    let urls = url.split("/");
    return urls[urls.length - 1];
};

export const sortHandler = (list, key, od = 'asc') => {
    if (!list) return [];
    if (!key) return list;

    let listArr = list // 새로 복사된 numbers

    if (od === 'asc') {
        listArr.sort((a, b) => { return a[key] - b[key] });
    } else {
        listArr.sort((a, b) => { return b[key] - a[key] });
    }

    // console.log(listArr);
    return listArr;
}

export const groupBy = (xs, key) => {

    return xs.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});

};

export const getDistanceFromLatLonInKm = (lat, lng, elat, elng) => {

    var lat1 = lat;
    var lng1 = lng;
    var lat2 = elat;
    var lng2 = elng;

    function deg2rad(deg) {
        return deg * (Math.PI / 180)
    }

    var r = 6371; //지구의 반지름(km)
    var dLat = deg2rad(lat2 - lat1);
    var dLon = deg2rad(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = r * c; // Distance in km
    return Math.round(d * 1000);

};


export const useInterval = (callback, delay) => {
    const savedCallback = useRef()

    // Remember the latest callback.
    useEffect(() => {
        savedCallback.current = callback
    }, [callback])

    // Set up the interval.
    useEffect(() => {
        const tick = () => {
            const { current } = savedCallback

            if (current !== undefined && current !== null) {
                current()
            }
        }
        if (delay !== null) {
            const id = setInterval(tick, delay)
            return () => clearInterval(id)
        }
        return () => { }
    }, [delay])
}

export const randomDigitCharactersSpecialCharacterslength = (lenth) => {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$&()_+~?|";
    for (var i = 0; i < lenth; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
};

export const isValidDate = (value) => {
    return value instanceof Date && !isNaN(value);
};

export const dateformat = (value) => {
    return moment(value).format('YYYY.MM.DD');
};
export const datetimeformat = (value) => {
    return moment(value).format('YYYY.MM.DD hh:mm:ss');
};



export const addHyphenToPhoneNumber = (phoneNumberInput) => {
    const phoneNumber = phoneNumberInput;
    const length = phoneNumber.length;

    if (length >= 9) {
        let numbers = phoneNumber.replace(/[^0-9]/g, "").replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`);
        return numbers;
    } else {
        return phoneNumberInput;

    }
};

export const getBase64 = (files) => {
    return new Promise(resolve => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(files);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            resolve(baseURL);
        };
        //console.log(fileInfo);
    });
}

export const getBase64toDataUrl = (url, callback) => {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
            callback(reader.result);
        }
        reader.readAsDataURL(xhr.response);
    };
    xhr.open('GET', url);
    xhr.responseType = 'blob';
    xhr.send();
}

export const getMemberinfo = (getmemberset, isSelUpdate = false) => {
    let memberinfos = {};
    APIS.postData('/v1/auth/info').then(({ data }) => {
        console.log("/v1/auth/info ->", data);
        getmemberset(data);
        try {
            console.log("setsel setdata!!!!")
            if (isSelUpdate) {
                const { selData } = data;
                store.dispatch(listsetting1({ listset1: JSON.parse(selData?.sel_list1) }));
                store.dispatch(listsetting2({ listset2: JSON.parse(selData?.sel_list2) }));
                store.dispatch(listsetting3({ listset3: JSON.parse(selData?.sel_list3) }));
                store.dispatch(listsetting1_2({ listset1_2: JSON.parse(selData?.sel_list1_2) }));
                store.dispatch(listsetting2_2({ listset2_2: JSON.parse(selData?.sel_list2_2) }));
                store.dispatch(listsetting3_2({ listset3_2: JSON.parse(selData?.sel_list3_2) }));
                store.dispatch(listsetting1_3({ listset1_3: JSON.parse(selData?.sel_list1_3) }));
                store.dispatch(listsetting2_3({ listset2_3: JSON.parse(selData?.sel_list2_3) }));
                store.dispatch(listsetting3_3({ listset3_3: JSON.parse(selData?.sel_list3_3) }));
                store.dispatch(
                    seltypeorcategory({
                        seltypes: selData?.type,
                        category_1s: selData?.category
                    })
                );
            }
        } catch (e) {
            console.log("setsel error!!", e)
        }
        //settermabort(data);
    }).catch((e) => {
        console.log(e);
    }).finally(() => {
    });

    return '';
}


export const Ismobiles = () => {

    return false;
}

export const useIntersectionObserver = (callback) => {
    const observer = useRef(
        new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        callback();
                    }
                });
            },
            { threshold: 1 }
        )
    );

    const observe = (element) => {
        observer.current.observe(element);
    };

    const unobserve = (element) => {
        observer.current.unobserve(element);
    };

    return [observe, unobserve];
}

export const polygon_point_check = (polygon_array, points_array, is_vertex = true) => {
    function array_unique(input_array) {
        input_array = JSON.parse(JSON.stringify(input_array)); //json stringify는 빈배열을 null로 바꿔준다.
        input_array = input_array.filter((element, i) => element !== null && element !== undefined && element !== ''); //빈키 삭제
        return [...new Set(input_array.join("|").split("|"))].map((v) => v.split(",")).map((v) => v.map((a) => +a)); //중복된 배열을 삭제한다.
    };

    //예외처리
    if (!Array.isArray(polygon_array) || !Array.isArray(points_array)) {
        return '폴리곤 혹은 좌표계 입력데이터가 배열이 아닙니다.';
    }

    //반환값을 사전에 정의한다.
    let output = new Array();
    output['inside'] = false;
    output['outside'] = false;

    //중복배열 삭제 및 데이터형변환
    polygon_array = array_unique(polygon_array);
    polygon_array.push(polygon_array[0]);


    //루프 바깥에 count를 달면 더 빠르다.
    let polygon_cnt = polygon_array.length;

    for (let points_key in points_array) {

        points_key = String(points_key);
        let points_xy = points_array[points_key];

        //데이터검사
        if (!Array.isArray(points_xy)) {
            return points_key + ' 의 좌표가 배열이 아닙니다.';
        }

        if (points_xy.length !== 2) {
            return points_key + ' 의 좌표의 위도, 경도 배열이 잘못되었습니다.';
        }


        if (String(points_xy[0]).indexOf('.') !== -1) {
            points_xy[0] = parseFloat(points_xy[0]);
        } else {
            points_xy[0] = parseInt(points_xy[0]);
        }
        if (String(points_xy[1]).indexOf('.') !== -1) {
            points_xy[1] = parseFloat(points_xy[1]);
        } else {
            points_xy[1] = parseInt(points_xy[1]);
        }

        let intersections = 0;
        for (let p = 0; p < polygon_cnt; p++) {

            //데이터검사
            if (!Array.isArray(polygon_array[p])) {
                return p + ' 번째 폴리곤 좌표가 배열이 아닙니다.';
            }
            if (polygon_array[p].length !== 2) {
                return p + ' 번째 폴리곤 좌표의 위도, 경도 배열이 잘못되었습니다.';
            }

            if (String(polygon_array[p][0]).indexOf('.') !== -1) {
                polygon_array[p][0] = parseFloat(polygon_array[p][0]);
            } else {
                polygon_array[p][0] = parseInt(polygon_array[p][0]);
            }
            if (String(polygon_array[p][1]).indexOf('.') !== -1) {
                polygon_array[p][1] = parseFloat(polygon_array[p][1]);
            } else {
                polygon_array[p][1] = parseInt(polygon_array[p][1]);
            }

            if (polygon_array[p].toString() === points_xy.toString()) {
                if (is_vertex) {
                    //겹침허용일때
                    output['inside'] = true;
                } else {
                    //겹침비허용일때
                    output['outside'] = true;
                }
                continue;
            }

            if (p === 0) {
                //첫번째 폴리곤배열은 이전과 비교할 데이터가 없음으로 넘어간다.
                continue;
            }

            if (polygon_array[p - 1][1] === polygon_array[p][1] &&
                polygon_array[p - 1][1] === points_xy[1] &&
                points_xy[0] > Math.min(polygon_array[p - 1][0], polygon_array[p][0]) &&
                points_xy[0] < Math.max(polygon_array[p - 1][0], polygon_array[p][0])
            ) {
                if (is_vertex) {
                    //겹침허용일때
                    output['inside'] = true;
                } else {
                    //겹침비허용일때
                    output['outside'] = true;
                }
                continue;
            }


            if (points_xy[1] > Math.min(polygon_array[p - 1][1], polygon_array[p][1]) &&
                points_xy[1] <= Math.max(polygon_array[p - 1][1], polygon_array[p][1]) &&
                points_xy[0] <= Math.max(polygon_array[p - 1][0], polygon_array[p][0]) &&
                polygon_array[p - 1][1] !== polygon_array[p][1]
            ) {

                let xinters = (points_xy[1] - polygon_array[p - 1][1]) *
                    (polygon_array[p][0] - polygon_array[p - 1][0]) /
                    (polygon_array[p][1] - polygon_array[p - 1][1]) + polygon_array[p - 1][0];

                if (xinters === points_xy[0]) {
                    if (is_vertex) {
                        //겹침허용일때
                        output['inside'] = true;
                    } else {
                        //겹침비허용일때
                        output['outside'] = true;
                    }
                    continue;
                }

                if (polygon_array[p - 1][0] === polygon_array[p][0] || points_xy[0] <= xinters) {
                    intersections++;
                }

            }


        }

        if (intersections % 2 !== 0) {
            output['inside'] = true;
            continue;
        } else {
            output['outside'] = true;
            continue;
        }

    }

    return output;
}

export const heckName = (name) => {
    //name의 마지막 음절의 유니코드(UTF-16) 
    const charCode = name.charCodeAt(name.length - 1);

    //유니코드의 한글 범위 내에서 해당 코드의 받침 확인
    const consonantCode = (charCode - 44032) % 28;

    if (consonantCode === 0) {
        //0이면 받침 없음 -> 를
        return `${name}를`;
    }
    //1이상이면 받침 있음 -> 을
    return `${name}을`;
}

export const geKoreanNumber = (number) => {
    let num = number;
    const hanA = ["", "일", "이", "삼", "사", "오", "육", "칠", "팔", "구"];
    const danA = ["", "십", "백", "천"];
    const unitA = ["", "만", "억", "조", "경"];
  
    if (typeof num !== "number" || isNaN(num)) return '';
  
    let result = '';
    let unitIndex = 0;
  
    while (num > 0) {
      let part = num % 10000;
      if (part > 0) {
        let partResult = '';
        for (let i = 0; i < 4; i++) {
          const digit = part % 10;
          if (digit > 0) {
            partResult = hanA[digit] + danA[i] + partResult;
          }
          part = Math.floor(part / 10);
        }
        result = partResult + unitA[unitIndex] + result;
      }
      num = Math.floor(num / 10000);
      unitIndex++;
    }
    return result || "영";
    //return answer.replace();
}

export const resizedataURL = (datas, wantedWidth, wantedHeight) => {
    return new Promise(async function (resolve, reject) {

        // We create an image to receive the Data URI
        var img = document.createElement('img');

        // When the event "onload" is triggered we can resize the image.
        img.onload = function () {
            // We create a canvas and get its context.
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');

            // We set the dimensions at the wanted size.
            canvas.width = wantedWidth;
            canvas.height = wantedHeight;

            const aspectRatio = img.width / img.height;

            // Calculate the best fit dimensions for the canvas
            if (wantedWidth / wantedHeight > aspectRatio) {
                canvas.width = wantedHeight * aspectRatio;
                canvas.height = wantedHeight;
            } else {
                canvas.width = wantedWidth;
                canvas.height = wantedWidth / aspectRatio;
            }

            // We resize the image with the canvas method drawImage();
            ctx.drawImage(this, 0, 0, canvas.width, canvas.height);

            var dataURI = canvas.toDataURL();
            //console.log(dataURI);
            // This is the return of the Promise
            resolve(dataURI);
        };

        // We put the Data URI in the image's src attribute
        img.src = datas;

    })
}

export const readFile = (file) => {
    var reader = new FileReader(),
        result = 'empty';

    reader.onload = function (e) {
        result = e.target.result;
        console.log(result);
    };

    reader.readAsText(file);

    return result;
}

export const readFileAsync = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => resolve("");
    });
}

export const pointInPolygon = (point, polygon) => {
    let x = point.x, y = point.y;
    let inside = false;

    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        let xi = polygon[i].x, yi = polygon[i].y;
        let xj = polygon[j].x, yj = polygon[j].y;

        let intersect = ((yi > y) != (yj > y)) &&
            (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }

    return inside;
}

export const filterItems = (item, customer) => {
    // console.log(polygons);
    try {
        let citys = customer?.citys?.filter(x => x.type === 1);
        let polygons = customer?.citys?.filter(x => x.type === 2)?.map(x => JSON.parse(x?.polygon));

        // 희망 지역 검사
        //console.log(customer, item?.sido);
        if (
            !citys?.find(x =>
                x?.sido === item?.sido &&
                (x?.sigungu === '전체' ? true : x?.sigungu === item?.sigungu) &&
                (x?.dong === '전체' ? true : x?.dong === item?.dong)
            ) &&
            !polygons?.find((x, i) => {
                // 매물 좌표
                const testPoint = { x: item?.lng, y: item?.lat };

                // 폴리곤 안에 있는지 확인
                const isInside = pointInPolygon(testPoint, x);
                // console.log(`주어진 점 (${testPoint.x}, ${testPoint.y})은 폴리곤 안에 ${isInside ? '있습니다.' : '없습니다.'}`);

                return isInside
            }
            )
        ) {
            return false;
        }


        // 매매가 or 보증금 검사
        if (item?.sell_type === '매매') {
            if (!(item?.price_sell >= (customer?.price_all_min || 0) && item?.price_sell <= (customer?.price_all_max || 99999999))) {
                return false;
            }
        } else {
            if (!(item?.price_all >= (customer?.price_all_min || 0) && item?.price_all <= (customer?.price_all_max || 99999999))) {
                return false;
            }
        }

        // 월세 검사
        if (item?.sell_type === '월세') {
            if (!(item?.price_month >= (customer?.price_month_min || 0) && item?.price_month <= (customer?.price_month_max || 99999999))) {
                return false;
            }
        }

        // 전용면적 검사
        let area_private = item?.area_private * 1;
        let item_area_min = customer?.item_area_min * 1;
        let item_area_max = customer?.item_area_max * 1;

        if (item?.category_2 * 1 === 3) {
            area_private = item?.area_floor * 1;
        }
        if (!(area_private >= (item_area_min || 0) && area_private <= (item_area_max || 99999999))) {
            return false;
        }
        // 희망 층수
        if (customer?.item_floor_min || customer?.item_floor_max) {
            let itemNumFloor = Number(item?.building_floor.replace(/\D/g, "")) || 1
            // if (!(item?.building_floor * 1 >= (customer?.item_floor_min || 1) && item?.building_floor * 1 <= (customer?.item_floor_max || 99999999))) {
            //     return false;
            // }
            if (!(itemNumFloor >= (customer?.item_floor_min || 1) && itemNumFloor <= (customer?.item_floor_max || 99999999))) {
                return false;
            }
        }


        // 희망 연식 최소
        if (customer?.item_year_min && !moment(item?.item_date).isSameOrAfter(moment(customer?.item_year_min + "0101"))) {
            return false;
        }
        // 희망 연식 최대
        if (customer?.item_year_max && !moment(item?.item_date).isSameOrBefore(moment(customer?.item_year_max + "1231"))) {
            return false;
        }

        // 실투자금
        if (customer?.price_real) {
            if (item?.sell_type === '매매' && (item?.price_sell - item?.now_price_all) > customer?.price_real) {
                return false;
            } else if ((item?.price_all + item?.price_keymoney) > customer?.price_real) {
                return false;
            }
        }

    } catch (error) {
        console.log('err', error);
        return false;
    }

    return true;
}

// 배열 쪼개기
export const chunkAtEnd = (value = "", n = 1) => {
    const result = [];

    for (let end = value.length; end > 0; end -= n) {
        result.push(value.substring(Math.max(0, end - n), end));
    }

    return result;
}


// 4자리씩 숫자로 변환
export const koreaNumber = (value) => {
    // 신규
    const units = ['', '만', '억', '조', '경', '해'];
    let unitIndex = 0;
    let number = Number(value);

    if (isNaN(number)) {
        return number
    }

    while (number >= 10000 && unitIndex < units.length - 1) {
        number /= 10000;
        unitIndex++;
    }

    let fixNum = 0
    if (!Number.isInteger(number)) {
        fixNum = 2; // 소수점일경우 2자리까지
    }

    return `${number.toFixed(fixNum)}${units[unitIndex]}`;

    // 옛날거
    const thousandUnits = ["", "만", "억", "조", "경", "해"];

    return chunkAtEnd(String(number), 4).reduce((acc, item, index) => {

        let unit = thousandUnits[index] ?? "";

        if (!Number(item)) {
            return acc;
        }

        // if(index === 1 && item?.length === 4) {
        //     item = item / 1000
        //     unit = '천만'
        // }

        return `${Number(item)}${unit} ${acc}`;
    }, "").trim();
}


/**
 * 두 값 더하기 
 * - 숫자가 아닐경우 0 으로 처리
 * @param {*} sum1 
 * @param {*} sum2 
 * @returns {number}
 */
export const anySumFunc = (sum1, sum2) => {
    let a = isNaN(Number(sum1)) ? 0 : Number(sum1);
    let b = isNaN(Number(sum2)) ? 0 : Number(sum2);

    return a + b;
}

export const filterItemsMain = (item = {}, realdatas = [], posdatas = []) => {
    //실거래 데이터
    let realcker = [];
    let finds = [];
    let area_privates = Math.floor(item?.area_private * 1);
    let area_floors = Math.floor(item?.area_floor * 1);
    // let building_dong_floor_all = Math.floor(item?.building_dong_floor_all * 1);
    let building_floor = Number((item?.building_floor.indexOf("지하") >= 0 ? "-" : "") + item?.building_floor.replace(patternOnlyNum, ""))
    if (item?.category_2 * 1 === 3 || item?.category_2 * 1 === 9 || item?.category_2 * 1 === 10 || item?.category_2 * 1 === 11) {
        if (item?.category_2 * 1 === 3) {
            let item_dates = item?.item_date?.substr(0, 4);
            if (item?.sell_type === '전세' || item?.sell_type === '월세') {
                realcker = realdatas?.filter(
                    item2 =>
                        (item2['식별코드'] === item?.p_code || item2['도로명코드'] === item?.p_code_sub) && item2['매물유형'] * 1 === item?.category_2 * 1 &&
                        item2['전월세구분'] === item?.sell_type &&
                        (item2['건축년도'] * 1 >= item_dates * 1 && item2['건축년도'] * 1 <= item_dates * 1)
                );
            } else {
                realcker = realdatas?.filter(
                    item2 =>
                        (item2['식별코드'] === item?.p_code || item2['도로명코드'] === item?.p_code_sub) && item2['매물유형'] * 1 === item?.category_2 * 1 &&
                        item2['전월세구분'] === item?.sell_type &&
                        (item2['건축년도'] * 1 >= item_dates * 1 && item2['건축년도'] * 1 <= item_dates * 1) &&
                        (item2['면적'] * 1 === area_floors * 1)
                );
            }
        }
        if (item?.category_2 * 1 === 9 || item?.category_2 * 1 === 10 || item?.category_2 * 1 === 11) {
            let item_dates = item?.item_date?.substr(0, 4);
            realcker = realdatas?.filter(
                item2 =>
                    (item2['식별코드'] === item?.p_code || item2['도로명코드'] === item?.p_code_sub) && item2['매물유형'] * 1 === item?.category_2 * 1 &&
                    item2['전월세구분'] === item?.sell_type &&
                    (item2['면적'] * 1 === area_floors * 1) &&
                    (item2['건축년도'] * 1 >= item_dates * 1 && item2['건축년도'] * 1 <= item_dates * 1)
            );
        }
    } else {
        // if (item?.p_code == "2629010600000740002") {
        //     console.log("find item?.p_code")
        // }
        realcker = realdatas?.filter(
            // item2 => item2['식별코드'] === item?.p_code && (item2['면적'] * 1 >= area_privates * 1 && item2['면적'] * 1 <= area_privates * 1) &&
            //     (item2['층'] * 1 >= building_dong_floor_all * 1 && item2['층'] * 1 <= building_dong_floor_all * 1)

            item2 => {
                return (item2['식별코드'] === item?.p_code || item2['도로명코드'] === item?.p_code_sub) &&
                    (item2['면적'] * 1 === area_privates * 1) && item2['매물유형'] * 1 === item?.category_2 * 1 &&
                    item2['전월세구분'] === item?.sell_type &&
                    (item2['층'] * 1 >= building_floor && item2['층'] * 1 <= building_floor);
            }
        );
    }
    // 인허가 데이터
    let poscker = posdatas?.filter(item2 => item2['식별코드'] === item?.p_code);
    //console.log(realcker, realcker);
    let orderDt = 0;
    if ((realcker || poscker)) {
        //console.log("realcker.length: ", realcker.length, poscker.length)
        if (poscker.length > 0) {
            finds = poscker[0];
            if (finds) {
                orderDt = moment(finds['인허가일자']).format('YYYYMMDD') * 1;
            }
        } else {
            finds = realcker[0];
            //console.log("🚀 ~ filterItemsMain ~ finds:", finds)
            //console.log(finds, x?.p_code);
            if (finds) {
                orderDt = (finds['계약년월'] + (finds['계약일'] * 1 < 10 ? `0${finds['계약일']}` : finds['계약일'])) * 1;
            }
        }
        if (finds) {
            item.order_dt = orderDt;
            return item;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

export const addStringUnit = (value, addStr) => {
    if (value == null || value == undefined)
        return ''

    if (addStr == null || addStr == undefined)
        return ''

    let addIndex = String(value).indexOf(addStr);
    if (addIndex >= 0) {
        return ""
    } else {
        return addStr
    }
}

export const filterItemsProduct = (item, customer) => {
    // console.log(polygons);
    try {
        let citys = customer?.citys?.filter(x => x.type === 1);
        let polygons = customer?.citys?.filter(x => x.type === 2)?.map(x => JSON.parse(x?.polygon));

        // 희망 지역 검사
        //console.log(customer, item?.sido);
        if (
            !citys?.find(x =>
                x?.sido === item?.sido &&
                (x?.sigungu === '전체' ? true : x?.sigungu === item?.sigungu) &&
                (x?.dong === '전체' ? true : x?.dong === item?.dong)
            ) &&
            !polygons?.find((x, i) => {
                // 매물 좌표
                const testPoint = { x: item?.lng, y: item?.lat };

                // 폴리곤 안에 있는지 확인
                const isInside = pointInPolygon(testPoint, x);
                // console.log(`주어진 점 (${testPoint.x}, ${testPoint.y})은 폴리곤 안에 ${isInside ? '있습니다.' : '없습니다.'}`);

                return isInside
            }
            )
        ) {
            return false;
        }


        // 매매가 or 보증금 검사
        if (item?.sell_type === '매매') {
            if (!(item?.price_sell >= (customer?.price_all_min || 0) && item?.price_sell <= (customer?.price_all_max || 99999999))) {
                return false;
            }
        } else {
            if (!(item?.price_all >= (customer?.price_all_min || 0) && item?.price_all <= (customer?.price_all_max || 99999999))) {
                return false;
            }
        }

        // 월세 검사
        if (item?.sell_type === '월세') {
            if (!(item?.price_month >= (customer?.price_month_min || 0) && item?.price_month <= (customer?.price_month_max || 99999999))) {
                return false;
            }
        }

        // 전용면적 검사
        let area_private = item?.area_private * 1;
        let item_area_min = customer?.item_area_min * 1;
        let item_area_max = customer?.item_area_max * 1;

        // if (item?.category_2 * 1 === 3) {
        //     area_private = item?.area_floor * 1;
        // }
        if (!(area_private >= (item_area_min || 0) && area_private <= (item_area_max || 99999999))) {
            return false;
        }
        // 희망 층수
        if (customer?.item_floor_min || customer?.item_floor_max) {
            let itemNumFloor = Number(item?.building_floor.replace(/\D/g, "")) || 1
            // if (!(item?.building_floor * 1 >= (customer?.item_floor_min || 1) && item?.building_floor * 1 <= (customer?.item_floor_max || 99999999))) {
            //     return false;
            // }
            if (!(itemNumFloor >= (customer?.item_floor_min || 1) && itemNumFloor <= (customer?.item_floor_max || 99999999))) {
                return false;
            }
        }


        // 희망 연식 최소
        if (customer?.item_year_min && !moment(item?.item_date).isSameOrAfter(moment(customer?.item_year_min + "0101"))) {
            return false;
        }
        // 희망 연식 최대
        if (customer?.item_year_max && !moment(item?.item_date).isSameOrBefore(moment(customer?.item_year_max + "1231"))) {
            return false;
        }

        // 실투자금
        if (customer?.price_real) {
            if (item?.sell_type === '매매' && (item?.price_sell - item?.now_price_all) > customer?.price_real) {
                return false;
            } else if ((item?.price_all + item?.price_keymoney) > customer?.price_real) {
                return false;
            }
        }

    } catch (error) {
        console.log('err', error);
        return false;
    }

    return true;
}